import { pageAfterLogin, canNavigateTo } from "@/utils/user_authorization"

export default function({ $auth, redirect, route }) {
  if(!canNavigateTo($auth.$state.user.roles, route.path)) 
    return redirect(pageAfterLogin($auth.$state.user.roles))
}
